/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Error_Empty_ResponseInputs */



/**
* | output |
* | --- |
* | "The model ended the response without answering. This is usually temporary — try again, or switch models if it keeps happening." |
*
* @param {Chat_Error_Empty_ResponseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_error_empty_response = /** @type {((inputs?: Chat_Error_Empty_ResponseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Error_Empty_ResponseInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Modell hat die Antwort beendet, ohne zu antworten. Das ist meist vorübergehend — versuche es erneut oder wechsle das Modell, wenn es wiederholt auftritt.")
	return /** @type {LocalizedString} */ ("The model ended the response without answering. This is usually temporary — try again, or switch models if it keeps happening.")
});